'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var cookie = require('js-cookie');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var cookie__default = /*#__PURE__*/_interopDefaultLegacy(cookie);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var biSdkWeb_min = {exports: {}};

(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,(function(){function t(e,o){return t=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t},t(e,o)}function e(t){for(var e=[0,1,2,3,4,5,6,7,8,9],o=10;1<o;o--){var r=Math.floor(10*Math.random()),n=e[r];e[r]=e[o-1],e[o-1]=n;}for(o=r=0;5>o;o++)r=10*r+e[o];return (t||"")+(r+"")+ +new Date}var o,r,n,i;!function(t){t.PAGE="page",t.EVENT="event";}(o||(o={})),function(t){t.ANDROID="android",t.IOS="ios",t.OTHER="other",t.INIT="init";}(r||(r={})),function(t){t.WX="wx",t.QQ="qq",t.MINIPROGRAM="miniprogram",t.INIT="init";}(n||(n={})),function(t){t.RECORD="bi_stat_records",t.PRE_EVENT="bi_stat_pre_event",t.STEP="bi_stat_step";}(i||(i={}));var s=1e4;return function(e){var o,i;function s(t){var o;return (o=e.call(this,t)||this).isUseBeacon=!1,o.postReportUrl="",o.host=location.host,o.isUseBeacon=t.isUseBeacon,o.postReportUrl=t.postReportUrl,o}i=e,(o=s).prototype=Object.create(i.prototype),o.prototype.constructor=o,t(o,i);var a=s.prototype;return a.httpGet=function(t,e){if(void 0===e&&(e={}),this.isUseBeacon){if(navigator.sendBeacon)return void this.sendBeaconReport(e);console.warn("navigator.sendBeacon not supported in this browser.");}(new Image).src=t;},a.sendBeaconReport=function(t){if(navigator.sendBeacon){var e=JSON.stringify([t]),o=new Blob([e],{type:"application/json"});navigator.sendBeacon(this.postReportUrl,o)||console.warn("Failed to send report data using navigator.sendBeacon.");}},a.getLocalStorage=function(t){return localStorage.getItem(t)},a.setLocalStorage=function(t,e){return localStorage.setItem(t,e)},a.getSessionStorage=function(t){return sessionStorage.getItem(t)},a.setSessionStorage=function(t,e){return sessionStorage.setItem(t,e)},a.getOS=function(){var t=navigator.userAgent,e=r.OTHER;return /android/gi.test(t)?e=r.ANDROID:/iPad|iPhone|iPod/.test(t)&&(e=r.IOS),e},a.getPlatform=function(){var t=navigator.userAgent,e=n.INIT;return /MicroMessenger/i.test(t)?e=n.WX:void 0!==window.mqq&&window.mqq.device&&(e=n.QQ),e},a.getPageUrl=function(){var t=location.pathname+location.hash.split("?")[0];return t=t.replace("#/",encodeURIComponent("#/"))},a.getScreen=function(){var t=window.screen;return t.width+"x"+t.height},s}(function(){function t(t){if(this.host="",this.clickTag="taclick",this.mtaUrl="https://pingtas.qq.com/webview/pingd?",this.beforeReport=null,this.shouldReport=null,this.os=r.INIT,this.platform=n.INIT,this.screen="",this.step={page:s,event:s},this.reportEventCache={},this.preEventID="first_event",this.dynamicInfo={},this.queue=[],!t)throw new Error("请传入配置参数");var e=t.sid,o=t.cid,a=t.beforeReport,c=void 0===a?null:a,h=t.shouldReport,g=void 0===h?null:h,p=t.isDev,u=void 0===p||p,f=t.version,d=void 0===f?"init":f,S=t.channelId,v=void 0===S?"":S;if(!e||!o)throw new Error("请配置sid, cid");Object.assign(this,{sid:e,cid:o,channelId:v,version:d,beforeReport:c,shouldReport:g,userId:this.getUserId(),sessionId:this.getSessionId(),os:this.getOS(),platform:this.getPlatform(),screen:this.getScreen(),reportEventCache:JSON.parse(this.getSessionStorage(i.RECORD)||"{}"),preEventID:this.getSessionStorage(i.PRE_EVENT)||this.preEventID,step:this.getInitStep(),isDev:Boolean(u),mtaUrl:this.mtaUrl});}var a=t.prototype;return a.eventStat=function(t,e){this.stat(t,o.EVENT,e);},a.pageStat=function(t,e){var r=e||this.getPageUrl();this.stat(r,o.PAGE,t);},a.setDynamicInfo=function(t){var e=t.openId,o=void 0===e?"":e,r=t.uin,n=void 0===r?"":r,i=t.accessId,s={fopenid:o,fuin:n,fsession_key:void 0===i?"":i},a=Object.assign({},t);delete a.openId,delete a.uin,delete a.accessId,this.dynamicInfo=Object.assign({},s,a);},a.flushQueue=function(){var t=this;this.queue.forEach((function(e){var o=Object.assign({},e);Object.assign(o.params,t.dynamicInfo),t.report(o);})),this.queue=[];},a.httpGet=function(t,e){throw new Error("请在SDK类实现httpGet方法")},a.getLocalStorage=function(t){throw new Error("请在SDK类实现getLocalStorage方法")},a.setLocalStorage=function(t,e){throw new Error("请在SDK类实现setLocalStorage方法")},a.getSessionStorage=function(t){throw new Error("请在SDK类实现getSessionStorage方法")},a.setSessionStorage=function(t,e){throw new Error("请在SDK类实现setSessionStorage方法")},a.getOS=function(){throw new Error("请在SDK类实现getOS方法")},a.getPlatform=function(){throw new Error("请在SDK类实现getPlatform方法")},a.getPageUrl=function(){throw new Error("请在SDK类实现getPageUrl方法")},a.getScreen=function(){throw new Error("请在SDK类实现getScr方法")},a.stat=function(t,e,o){var r={type:e,key:t,params:this.addBIParams(t,e,o)};if(this.beforeReport){var n=this.beforeReport(r);n&&(r=n);}var i=!0;this.shouldReport&&(i=this.shouldReport(r)),i&&(r.queue?(delete r.queue,this.queue.push(r)):this.report(r));},a.addBIParams=function(t,e,o){var r=this.getPageUrl();return Object.assign({fplat_form:this.platform,fos:this.os,fchannel_id:this.channelId,ftimestamp:(new Date).getTime(),findex:this.getStep(e),furl:r,freport:this.getReportTimes(r,t),fversion:this.version,fpre_event_id:this.getPreEventId(t),fsituation:this.isDev?"1":"2",fscr:this.screen},o,this.dynamicInfo)},a.report=function(t){var e=t.key,r=t.type,n=t.params,i={url:e,dm:"",r2:"",pvi:this.userId,si:this.sessionId,random:(new Date).getTime()};r===o.EVENT?Object.assign(i,{dm:this.clickTag,r2:this.cid,r5:encodeURIComponent(JSON.stringify(n))}):r===o.PAGE&&Object.assign(i,{dm:this.host,r2:this.sid,ext:encodeURIComponent(JSON.stringify(n))});var s=Object.keys(i).map((function(t){return t+"="+i[t]})),a=""+this.mtaUrl+s.join("&");this.httpGet(a,i);},a.getUserId=function(){var t="bi_user_id",o=this.getLocalStorage("pgv_pvi")||this.getLocalStorage("_mta_auid")||this.getLocalStorage(t)||"";return o||(o=e(),this.setLocalStorage(t,o)),o},a.getSessionId=function(){var t="bi_session_id",o=this.getSessionStorage("pgv_si")||this.getSessionStorage(t)||"";return o||(o=e("s"),this.setSessionStorage(t,o)),o},a.getReportTimes=function(t,e){var o=this,r=t+"_"+e;return this.reportEventCache[r]?"2":(this.reportEventCache[r]=!0,this.recordSaveTimer&&clearTimeout(this.recordSaveTimer),this.recordSaveTimer=setTimeout((function(){o.setSessionStorage(i.RECORD,JSON.stringify(o.reportEventCache));}),300),"1")},a.getPreEventId=function(t){var e=this.preEventID;return this.preEventID=t,this.setSessionStorage(i.PRE_EVENT,this.preEventID),e},a.getInitStep=function(){var t=this.getSessionStorage(i.STEP);return t?JSON.parse(t):this.step},a.getStep=function(t){return t===o.PAGE?(this.step.page+=1,this.step.event=s,this.setSessionStorage(i.STEP,JSON.stringify(this.step)),""+this.step.page):(this.step.event+=1,this.setSessionStorage(i.STEP,JSON.stringify(this.step)),this.step.page+"."+this.step.event)},t}())}));
}(biSdkWeb_min));

var BI$1 = biSdkWeb_min.exports;

/** cookie中的 uin key，香港钱包为 qluin */

var uinKey = 'qluin';
/** cookie中的 fuin key */

var fuinKey = 'qluin';
var fuin = '';
/** 设置 cookie 中存储 uin 的key */

function setUinKey(key) {
  uinKey = key;
}
/** 设置 cookie 中 fuin 的key */

function setFuinKey(key) {
  fuinKey = key;
}
/** 直接设置 fuin */

function setFuin(value) {
  fuin = value;
}
/**
 * 获取用户uin
 */

function getUin() {
  // 业务侧不一定是qluin 所以要允许自定义 比如话费是ia_refill_qluin
  return cookie__default["default"].get(uinKey) || '';
}
/**
 * 获取用户fuin。若未存储 fuin, 则与 uin 一致
 */

function getFuin() {
  return fuin || cookie__default["default"].get(fuinKey) || getUin();
}

/** 业务大类，钱包vs运营 */
var BusinessSpace;

(function (BusinessSpace) {
  /** 钱包基础功能 */
  BusinessSpace["WALLET"] = "wallet";
  /** 运营活动 */

  BusinessSpace["PROM"] = "promotion";
})(BusinessSpace || (BusinessSpace = {}));
/**
 * 操作(事件)类型
 */


exports.Operation = void 0;

(function (Operation) {
  /** 点击事件 */
  Operation["CLICK"] = "click";
  /** 曝光事件, 仅上报一次 */

  Operation["BROW"] = "brow";
  /** 曝光事件, 元素出现时就会上报，适合希望多次上报或有 v-show 的情况 */

  Operation["BROW_MULT"] = "brow_mult";
  Operation["LEAVE"] = "leave";
  Operation["SCROLL"] = "scroll";
  Operation["HEAT_MAP"] = "heat_map";
  Operation["CLOSE"] = "close";
})(exports.Operation || (exports.Operation = {}));
/**
 * 默认的组件字段，A.B.C 上报字段中的 B 部分
 * 无法确认组件归属时默认使用
 */


var ComponentTag;

(function (ComponentTag) {
  ComponentTag["TEMPLATE"] = "_template";
  ComponentTag["PAGE"] = "_page";
  ComponentTag["LOGIC"] = "_logic";
})(ComponentTag || (ComponentTag = {}));
/** 是否允许为空 */


exports.EIsNull = void 0;

(function (EIsNull) {
  EIsNull["no"] = "0";
  EIsNull["yes"] = "1";
})(exports.EIsNull || (exports.EIsNull = {}));
/** 自定义指令参数类型 */

var DirectiveParamsKey;

(function (DirectiveParamsKey) {
  /** 是否懒加载 */
  DirectiveParamsKey["isLazy"] = "isLazy";
  /** 是否支持多次上报 */

  DirectiveParamsKey["isMultBrow"] = "isMultBrow";
})(DirectiveParamsKey || (DirectiveParamsKey = {}));

/**
 * 项目相关的全局信息，通常从 mta-config-global.ts 读取。
 */

var mtaGlobalConf = {
  /** 业务 */
  group: BusinessSpace.WALLET,

  /** 项目id */
  project: '',
  enableRouteListen: false,
  closeCheckExtF: false,
  closePv: {
    h5: false,
    mp: false
  },
  route: undefined
};
/**
 * 从传入的配置中，获取并设置group（业务-一级分类）和project（项目名-二级分类）
 */

var setGlobalConfig = function setGlobalConfig(conf) {
  mtaGlobalConf.group = conf.group;
  mtaGlobalConf.project = conf.project;
  mtaGlobalConf.closeCheckExtF = !!conf.closeCheckExtF;
  mtaGlobalConf.enableRouteListen = conf.enableRouteListen;
  mtaGlobalConf.closePv = conf.closePv || {
    h5: false,
    mp: false
  };
  mtaGlobalConf.route = conf.route;
  mtaGlobalConf.reportAfterUin = conf.reportAfterUin || false;
};
var getGlobalConfig = function getGlobalConfig() {
  return mtaGlobalConf;
};

/** 只有在开发环境，将信息输出到控制台 */
function debug() {
  if (process.env.NODE_ENV === 'development') {
    var _console;

    (_console = console).log.apply(_console, arguments);
  }
}

/**
 * 获取 url 参数
 * @param name 参数名称
 * @returns 参数值，如果没有则返回 ‘’
 */
// https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
function getUrlParameter(name) {
  var key = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp("[\\?&]".concat(key, "=([^&#]*)"));
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
/**
 * 获取 url hash 参数
 * @param name 参数名称
 * @returns 参数值，如果没有则返回 ‘’
 */

function getUrlHashParameter(name) {
  var key = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp("[\\#&?]".concat(key, "=([^&#]*)"));
  var results = regex.exec(location.hash);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

/**
 * TODO: 是否需要考虑 baselibs 中原有的通过 iframe 的 session storage 来获取 adtag 的方式？
 * 获取url参数中的adtag值
 * @export
 * @returns
 */

function getParamAdtag() {
  var tag = getUrlParameter('hottag') || getUrlHashParameter('hottag') || getUrlParameter('adtag') || getUrlHashParameter('adtag') || getUrlParameter('ADTAG') || getUrlHashParameter('ADTAG');
  debug('getParamAdtag', tag);
  return tag;
}

var getUserAgent = function getUserAgent() {
  return navigator.wxuserAgent || navigator.userAgent;
};
/**
 * 获取OS信息
 */


function getOSInfoObj() {
  var userAgent = getUserAgent();
  var pattern = /iPhone OS ([\d_]+)/i;
  var wc = userAgent.match(pattern);
  if (wc) return {
    type: 'iphone',
    version: wc[1].replace('_', '.')
  };
  pattern = /Android ([\d.]+)/i;
  wc = userAgent.match(pattern);
  if (wc) return {
    type: 'android',
    version: wc[1]
  };
  return {
    type: 'none',
    version: '0.0.0'
  };
}
/**
 * 获取微信版本
 */

function getWeixinVer() {
  var userAgent = getUserAgent(); // ...MicroMessenger/7.0.1380(0x2700003D)...获取(0x....)

  var pattern = /MicroMessenger\/[\d.]+\((.*)\)/i;
  var wc = userAgent.match(pattern);

  if (!wc) {
    pattern = /MicroMessenger\/([\d.]+)/i;
    wc = userAgent.match(pattern);
    if (wc) return wc[1];
  }

  if (!wc) return '0.0.0';
  var version = wc[1].slice(3);
  var result = [];
  result.push(parseInt(version.slice(0, 1), 16));
  result.push(parseInt(version.slice(1, 3), 16));
  result.push(parseInt(version.slice(3, 5), 16));
  return result.join('.') || '0.0.0';
}

/** 默认语言 */

var DEFAULT_LANG_MAP = ['zh-cn', 'zh-hk', 'en'];
var DEFAULT_LANG = 'en';
var LANG_KEY = 'lang';
/**
 * 从指定的范围中选择语言，如果没有，则返回默认语言
 */

function getLanguage() {
  var lang = getLangFromUrl(LANG_KEY) || getLangFromUa() || getLangFromNavigator();
  lang = formatLang(lang);
  var formattedArr = DEFAULT_LANG_MAP.map(formatLang);
  return formattedArr.indexOf(lang) > -1 ? lang : DEFAULT_LANG;
}

function formatLang(lang) {
  return lang.replace(/_/g, '-');
}
/**
 * 优先从url获取语言，否则从useragent中取
 */


function getLangFromUrl() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'lang';
  return getUrlParameter(key) || '';
}
/**
 * 从ua获取语言 适用于微信内部webview
 */


function getLangFromUa() {
  var matchResult = (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) === 'object' ? navigator.userAgent.match(/\s*Language\/([^\s]+)/) : '';
  return matchResult !== null && matchResult !== void 0 && matchResult[1] ? matchResult[1].toLowerCase() : '';
}
/**
 * 从navigator中获取
 */


function getLangFromNavigator() {
  return (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) === 'object' ? navigator.language : '';
}

/** 默认操作类型 */

var DEFAULT_OPERATION = exports.Operation.CLICK;
/**
 * 组件名称默认为_logic 表示逻辑层上报（无特定的组件归属）
 */

var DEFAULT_COMPONENT_TAG = ComponentTag.LOGIC;

/**
 * @param event 事件名
 * @param fn 回调函数
 * @param once 触发一次事件处理函数后是否remove?
 */
var on = function on(event, fn) {
  var once = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  window.addEventListener(event, function a(i) {
    once && window.removeEventListener(event, a, true);
    fn.call(this, i);
  }, true);
};

/**
 * 为H5增加新的自定义事件
 * @param eventName 自定义事件名称
 * @param detail 自定义事件的event.detail参数的值
 */

var dispatchCustomEvent = function dispatchCustomEvent(eventName, detail) {
  var mockEvent;

  if (window.CustomEvent) {
    mockEvent = new CustomEvent(eventName, {
      detail: detail
    });
  } else {
    mockEvent = window.document.createEvent('HTMLEvents');
    mockEvent.initEvent(eventName, false, true);
    mockEvent.detail = detail;
  }

  window.dispatchEvent(mockEvent);
};
/**
 * 监听页面的popstate事件
 */

function hackOnpopstate() {
  // 代理劫持
  var _window = window,
      onpopstate = _window.onpopstate;

  window.onpopstate = function (e) {
    var page = getPageName();
    setPageName(page);
    if (onpopstate) return onpopstate.call(this, e);
  };
}
/**
 * hack pushstate replaceState
 * 派送historystatechange 事件
 * @param event 'pushState' | 'replaceState'
 */

var hasHackPopstate = false;
function hackState(event) {
  if (hasHackPopstate) return;
  var EventHandleFn = history[event];
  typeof EventHandleFn === 'function' && (history[event] = function (data, title, url) {
    hackOnpopstate(); // 调用pushState或replaceState时hack Onpopstate

    hasHackPopstate = true;
    var states = [data, title, url];
    var _location = location,
        href = _location.href;
    var fnResult = EventHandleFn.apply(history, states);
    if (!url || typeof url !== 'string') return fnResult;
    if (url === href) return fnResult;
    dispatchCustomEvent('historystatechanged', url);
    return fnResult;
  });
}
var mapFunc = function mapFunc(p) {
  return p;
};
var getCurrentPage = function getCurrentPage() {
  var _location$hash;

  // 1. 去掉问号 2. 去掉#
  var page = (_location$hash = location.hash) === null || _location$hash === void 0 ? void 0 : _location$hash.split('?')[0].slice(1);

  if (typeof mapFunc === 'function') {
    return mapFunc(page);
  }

  return page;
};
/**
 * 针对目前pageName在uni的H5侧有修改的需要
 * @param fn 此函数对原pageName进行map，返回业务侧需要上报的名字，函数的输入为originPageNmae,
 * 输出为新的要上报的pageName
 */

function setMapPageNameFun(fn) {
  mapFunc = fn;
}
var listeners$1 = [];
var lastHash = getHash();
/**
 * 路由变化监听
 * @param route 可以把vue-router传进来
 */

function routeChangeListen(route, configOptions) {
  hackState('pushState');
  hackState('replaceState');
  on('hashchange', function () {
    routeChangeHandler({
      shouldSetPageName: true,
      configOptions: configOptions
    });
  });
  on('historystatechanged', function (_e) {
    routeChangeHandler({
      shouldSetPageName: true,
      configOptions: configOptions
    });
  });
  on('beforeunload', function () {
    // 页面没跳转，不需要设置pageName和lastHash
    routeChangeHandler({
      shouldSetPageName: false,
      configOptions: configOptions
    });
  });
  on('unload', function () {
    // 页面没跳转，不需要设置pageName和lastHash
    routeChangeHandler({
      shouldSetPageName: false,
      configOptions: configOptions
    });
  });
  on('locationChange', function (event) {
    // 页面没跳转，不需要设置pageName和lastHash
    routeChangeHandler({
      isLocationChange: true,
      detail: event.detail,
      configOptions: configOptions
    });
  }); // vue-router的回调会设置pageName 所以这里不需要

  route === null || route === void 0 ? void 0 : route.beforeEach(function (from, to, next) {
    routeChangeHandler({
      shouldSetPageName: false,
      configOptions: configOptions
    });
    next();
  });
}
/**
 * 路由监听的处理函数
 */

function routeChangeHandler(_ref) {
  var shouldSetPageName = _ref.shouldSetPageName,
      isLocationChange = _ref.isLocationChange,
      detail = _ref.detail,
      configOptions = _ref.configOptions;
  var from = lastHash;
  var to = getHash();

  if (shouldSetPageName) {
    lastHash = to;
    setPageName(getCurrentPage());
  }

  listeners$1.forEach(function (_ref2) {
    var listenFn = _ref2.listenFn;

    if (!isLocationChange) {
      listenFn(from, to, configOptions);
    } else {
      var _detail$url;

      // 触发locationChange的时候需要带上自定义参数detail，携带url作为to，否则就用随机值作为to;
      !(detail !== null && detail !== void 0 && detail.url) && console.warn('请携带detail对象，对象需要包含url键');
      listenFn(from, (_detail$url = detail === null || detail === void 0 ? void 0 : detail.url) !== null && _detail$url !== void 0 ? _detail$url : new Date().toISOString(), configOptions);
    }
  });
  listeners$1 = listeners$1.filter(function (_ref3) {
    var once = _ref3.once;
    return once === false;
  });
}
/**
 * 把回调函数加入监听队列，页面跳转时会调用队列的回调函数
 * @param callback 页面跳转的回调函数
 * @param once 回调函数是否要持久使用，可以使用一次就销毁
 */


function onRouteChange(listenFn) {
  var once = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  listeners$1.push({
    listenFn: listenFn,
    once: once
  });
}
/**
 * 拿到当前的页面的hash值，#开头，如"#/pages/sv-right/index"
 * @returns 获取当前页面的hash
 */

function getHash() {
  var _location2, _location2$hash;

  return (_location2 = location) === null || _location2 === void 0 ? void 0 : (_location2$hash = _location2.hash) === null || _location2$hash === void 0 ? void 0 : _location2$hash.split('?')[0];
}

// 处理页面相关的逻辑，监听路由获取当前页面名称，拼接上报 A 字段等。
/** 默认页面名称 */

var defaultPageName = 'index';
/** 为路由中定义的 name 属性，例如 index */

var pageName = defaultPageName;
/** 获取当前页面名称 */

var getPageName = function getPageName() {
  return pageName;
};
var setPageName = function setPageName(name) {
  return pageName = name;
};
var pageReportHistory = {};
/** 监听路由变化，获取 当前页面名字 */

var initRouteListener = function initRouteListener(route, routeChangeHandler) {
  if (!route) {
    throw '必须引入vue-router插件，且必须在上报插件前引入';
  }

  route.beforeEach(function (to, _from, next) {
    // 记录当前页面key
    var nextName = getRouterName(to);

    if (pageName !== nextName) {
      pageName = nextName;
      routeChangeHandler(pageName);
    }

    next();
  });

  if (getGlobalConfig().enableRouteListen) {
    onRouteChange(function (_from, _to, configOptions) {
      var _configOptions$closeP;

      // pv上报
      var hash = getHash().slice(1);

      if (!((_configOptions$closeP = configOptions.closePv) !== null && _configOptions$closeP !== void 0 && _configOptions$closeP.h5) && !pageReportHistory[hash]) {
        exports.bi.pageStat({
          findex: 0,
          faction: exports.Operation.BROW
        }, hash);
        pageReportHistory[hash] = true;
      }
    }, false);
  }
};
/** 获取路由name */

function getRouterName(to) {
  var _to$matched;

  var parentName = '';
  var matchedArr = (_to$matched = to.matched) !== null && _to$matched !== void 0 ? _to$matched : [];

  if ((matchedArr === null || matchedArr === void 0 ? void 0 : matchedArr.length) > 1) {
    // 如果是子路由，必然会matched > 1(自己的和父路由的)
    var len = matchedArr.length;

    for (var i = 0; i < len; i++) {
      if (matchedArr[i].parent) {
        console.log('bi: 当前路由为子路由', to); // 存在父路由

        parentName = matchedArr[i].parent.name;
        break;
      }
    }
  } // 如果是子路由，则返回父路由的name(解决父路由 -> 子路由时，当前页面router生命周期执行两次，两次之间的数据上报会出现“父name/子name”不确定的情况)


  return parentName || (to === null || to === void 0 ? void 0 : to.name) || (to === null || to === void 0 ? void 0 : to.path) || defaultPageName;
}
/**
 * 格式化上报的页面ID部分，即上报字段 A.B.C 的 A 部分，
 * A的生成规则为：`${一级分类name}_${二级分类name}_${路由name}`
 *
 * @param group  一级分类 为业务大类，例如 wallet 钱包，或 promotion 运营
 * @param project 二级分类 为项目名称，例如 fps
 * @param pageName 路由name 即为路由中定义的 name 属性，例如 index
 * @returns
 */

var formatPageKey = function formatPageKey(group, project, pageName) {
  return "".concat(group, "_").concat(project, "_").concat(pageName);
};

var biSdkMinipro_min = {exports: {}};

(function (module, exports) {
(function (global, factory) {
  module.exports = factory() ;
})(commonjsGlobal, (function () {
  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }

  function generateUserId(r) {
    // eslint-disable-next-line
    for (var a = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9], o = 10; 1 < o; o--) {
      var n = Math.floor(10 * Math.random()),
        t = a[n];
      a[n] = a[o - 1], a[o - 1] = t;
    }
    for (o = n = 0; 5 > o; o++) n = 10 * n + a[o];
    return (r || "") + (n + "") + +new Date();
  }

  /**
   * Core：平台无关逻辑
   */
  var IReportType;
  (function (IReportType) {
    IReportType["PAGE"] = "page";
    IReportType["EVENT"] = "event";
  })(IReportType || (IReportType = {}));
  var IOSType;
  (function (IOSType) {
    IOSType["ANDROID"] = "android";
    IOSType["IOS"] = "ios";
    IOSType["OTHER"] = "other";
    IOSType["INIT"] = "init";
  })(IOSType || (IOSType = {}));
  var IPlatpormType;
  (function (IPlatpormType) {
    IPlatpormType["WX"] = "wx";
    IPlatpormType["QQ"] = "qq";
    IPlatpormType["MINIPROGRAM"] = "miniprogram";
    IPlatpormType["INIT"] = "init";
  })(IPlatpormType || (IPlatpormType = {}));
  var IStoreKey;
  (function (IStoreKey) {
    IStoreKey["RECORD"] = "bi_stat_records";
    IStoreKey["PRE_EVENT"] = "bi_stat_pre_event";
    IStoreKey["STEP"] = "bi_stat_step";
  })(IStoreKey || (IStoreKey = {}));
  var STEP_INIT = 10000;
  var Core = /*#__PURE__*/function () {
    function Core(option) {
      // SDK实现差异变量
      this.host = '';
      this.clickTag = 'taclick';
      this.mtaUrl = 'https://pingtas.qq.com/webview/pingd?';
      this.beforeReport = null;
      this.shouldReport = null;
      this.os = IOSType.INIT;
      this.platform = IPlatpormType.INIT;
      this.screen = '';
      this.step = {
        page: STEP_INIT,
        event: STEP_INIT
      };
      this.reportEventCache = {}; // 上报缓存，用于判断首次还是第二次
      this.preEventID = 'first_event';
      this.dynamicInfo = {}; // 动态上报信息，业务可通过setDynamicInfo来修改
      this.queue = []; // 暂不上报的队列
      // 平台无关参数处理
      if (!option) {
        throw new Error('请传入配置参数');
      }
      var sid = option.sid,
        cid = option.cid,
        _option$beforeReport = option.beforeReport,
        beforeReport = _option$beforeReport === void 0 ? null : _option$beforeReport,
        _option$shouldReport = option.shouldReport,
        shouldReport = _option$shouldReport === void 0 ? null : _option$shouldReport,
        _option$isDev = option.isDev,
        isDev = _option$isDev === void 0 ? true : _option$isDev,
        _option$version = option.version,
        version = _option$version === void 0 ? 'init' : _option$version,
        _option$channelId = option.channelId,
        channelId = _option$channelId === void 0 ? '' : _option$channelId;
      if (!sid || !cid) {
        throw new Error('请配置sid, cid');
      }
      Object.assign(this, {
        sid: sid,
        cid: cid,
        channelId: channelId,
        version: version,
        beforeReport: beforeReport,
        shouldReport: shouldReport,
        userId: this.getUserId(),
        sessionId: this.getSessionId(),
        os: this.getOS(),
        platform: this.getPlatform(),
        screen: this.getScreen(),
        reportEventCache: JSON.parse(this.getSessionStorage(IStoreKey.RECORD) || '{}'),
        preEventID: this.getSessionStorage(IStoreKey.PRE_EVENT) || this.preEventID,
        step: this.getInitStep(),
        isDev: Boolean(isDev),
        mtaUrl: this.mtaUrl
      });
    }
    var _proto = Core.prototype;
    _proto.eventStat = function eventStat(key, params) {
      this.stat(key, IReportType.EVENT, params);
    };
    _proto.pageStat = function pageStat(params, url) {
      var key = url || this.getPageUrl();
      this.stat(key, IReportType.PAGE, params);
    }
    // 设置动态上报信息
    // @TODO 评审是否需要支持分批添加（目前每次设置都会全量覆盖dynamicInfo）
    ;
    _proto.setDynamicInfo = function setDynamicInfo(params) {
      var _params$openId = params.openId,
        openId = _params$openId === void 0 ? '' : _params$openId,
        _params$uin = params.uin,
        uin = _params$uin === void 0 ? '' : _params$uin,
        _params$accessId = params.accessId,
        accessId = _params$accessId === void 0 ? '' : _params$accessId;
      var renameParams = {
        fopenid: openId,
        fuin: uin,
        fsession_key: accessId
      };
      var otherParams = Object.assign({}, params);
      delete otherParams.openId;
      delete otherParams.uin;
      delete otherParams.accessId;
      this.dynamicInfo = Object.assign({}, renameParams, otherParams);
    }
    // 清空上报队列
    ;
    _proto.flushQueue = function flushQueue() {
      var _this = this;
      this.queue.forEach(function (reportData) {
        var finalReportData = Object.assign({}, reportData);
        Object.assign(finalReportData.params, _this.dynamicInfo);
        _this.report(finalReportData);
      });
      this.queue = [];
    }
    // 由子类实现
    ;
    _proto.httpGet = function httpGet(url, mtaData) {
      throw new Error('请在SDK类实现httpGet方法');
    };
    _proto.getLocalStorage = function getLocalStorage(key) {
      throw new Error('请在SDK类实现getLocalStorage方法');
    };
    _proto.setLocalStorage = function setLocalStorage(key, value) {
      throw new Error('请在SDK类实现setLocalStorage方法');
    };
    _proto.getSessionStorage = function getSessionStorage(key) {
      throw new Error('请在SDK类实现getSessionStorage方法');
    };
    _proto.setSessionStorage = function setSessionStorage(key, value) {
      throw new Error('请在SDK类实现setSessionStorage方法');
    };
    _proto.getOS = function getOS() {
      throw new Error('请在SDK类实现getOS方法');
    };
    _proto.getPlatform = function getPlatform() {
      throw new Error('请在SDK类实现getPlatform方法');
    };
    _proto.getPageUrl = function getPageUrl() {
      throw new Error('请在SDK类实现getPageUrl方法');
    };
    _proto.getScreen = function getScreen() {
      throw new Error('请在SDK类实现getScr方法');
    }
    // @NOTE 核心上报流程（参数添加，上报前业务处理，上报拦截，上报）
    ;
    _proto.stat = function stat(key, type, params) {
      var finalParams = this.addBIParams(key, type, params);
      var reportData = {
        type: type,
        key: key,
        params: finalParams
      };
      if (this.beforeReport) {
        // @ts-ignore
        var processData = this.beforeReport(reportData);
        if (processData) {
          reportData = processData;
        }
      }
      var canReport = true;
      if (this.shouldReport) {
        // @ts-ignore
        canReport = this.shouldReport(reportData);
      }
      if (canReport) {
        // 是否放入队列中
        if (reportData.queue) {
          delete reportData.queue;
          this.queue.push(reportData);
        } else {
          this.report(reportData);
        }
      }
    };
    _proto.addBIParams = function addBIParams(key, type, params) {
      var url = this.getPageUrl();
      return Object.assign({
        fplat_form: this.platform,
        fos: this.os,
        fchannel_id: this.channelId,
        ftimestamp: new Date().getTime(),
        findex: this.getStep(type),
        furl: url,
        freport: this.getReportTimes(url, key),
        fversion: this.version,
        fpre_event_id: this.getPreEventId(key),
        fsituation: this.isDev ? '1' : '2',
        fscr: this.screen
      }, params, this.dynamicInfo);
    };
    _proto.report = function report(reportData) {
      var key = reportData.key,
        type = reportData.type,
        params = reportData.params;
      var mtaData = {
        url: key,
        dm: '',
        r2: '',
        pvi: this.userId,
        si: this.sessionId,
        random: new Date().getTime()
      };
      if (type === IReportType.EVENT) {
        Object.assign(mtaData, {
          dm: this.clickTag,
          r2: this.cid,
          r5: encodeURIComponent(JSON.stringify(params))
        });
      } else if (type === IReportType.PAGE) {
        Object.assign(mtaData, {
          dm: this.host,
          r2: this.sid,
          ext: encodeURIComponent(JSON.stringify(params))
        });
      }
      var urlParams = Object.keys(mtaData).map(function (mtakey) {
        return mtakey + "=" + mtaData[mtakey];
      });
      var url = "" + this.mtaUrl + urlParams.join('&');
      // 生成上报url
      this.httpGet(url, mtaData);
    }
    /**
     * 获取用户id: 从localstorage中获取，没有的话自动生成并存入
     * 优先取mta sdk生成的pvi，这样能避免mta系统的uv统计不准确（如果重新生成uv，相当于新增了一个用户）
     */;
    _proto.getUserId = function getUserId() {
      var BI_USER_ID_KEY = 'bi_user_id';
      // @ts-ignore
      var userId = this.getLocalStorage('pgv_pvi') || this.getLocalStorage('_mta_auid') || this.getLocalStorage(BI_USER_ID_KEY) || '';
      if (!userId) {
        userId = generateUserId();
        this.setLocalStorage(BI_USER_ID_KEY, userId);
      }
      return userId;
    }
    /**
     * 获取用户sessionId: 从session中获取，没有的话自动生成并存入
     */;
    _proto.getSessionId = function getSessionId() {
      var BI_SESSION_ID_KEY = 'bi_session_id';
      // @ts-ignore
      var sessionId = this.getSessionStorage('pgv_si') || this.getSessionStorage(BI_SESSION_ID_KEY) || '';
      if (!sessionId) {
        sessionId = generateUserId('s');
        this.setSessionStorage(BI_SESSION_ID_KEY, sessionId);
      }
      return sessionId;
    }
    /**
     * 获取上报次数标识，首次为'1'，非首次为'2'
     * @NOTE session溢出风险评估
     * 1. 容量为5MB
     * 2. 一条记录 = 77(英文字符串长度) / 1024 = 0.075KB
     * 3. 假设极限情况下用户访问50个页面，一个页面有100条不同的事件上报 = 50 * 100 * 0.075 = 375KB
     * 4. 优化处理：
     *  4.1 异步存储处理
     *  4.2 可通过签名算法，把长度控制在32位左右
     */;
    _proto.getReportTimes = function getReportTimes(url, eventName) {
      var _this2 = this;
      var key = url + "_" + eventName;
      if (!this.reportEventCache[key]) {
        this.reportEventCache[key] = true;
        // 节流处理
        if (this.recordSaveTimer) {
          clearTimeout(this.recordSaveTimer);
        }
        this.recordSaveTimer = setTimeout(function () {
          _this2.setSessionStorage(IStoreKey.RECORD, JSON.stringify(_this2.reportEventCache));
        }, 300);
        return '1';
      }
      return '2';
    };
    _proto.getPreEventId = function getPreEventId(key) {
      var id = this.preEventID;
      this.preEventID = key;
      this.setSessionStorage(IStoreKey.PRE_EVENT, this.preEventID);
      return id;
    }
    // 用缓存或初始化的step
    ;
    _proto.getInitStep = function getInitStep() {
      var step = this.getSessionStorage(IStoreKey.STEP);
      if (step) {
        return JSON.parse(step);
      }
      return this.step;
    };
    _proto.getStep = function getStep(type) {
      if (type === IReportType.PAGE) {
        this.step.page += 1;
        this.step.event = STEP_INIT;
        this.setSessionStorage(IStoreKey.STEP, JSON.stringify(this.step));
        return "" + this.step.page;
      }
      this.step.event += 1;
      this.setSessionStorage(IStoreKey.STEP, JSON.stringify(this.step));
      return this.step.page + "." + this.step.event;
    };
    return Core;
  }();

  var biSession = {};
  var BI = /*#__PURE__*/function (_Core) {
    _inheritsLoose(BI, _Core);
    function BI() {
      return _Core.apply(this, arguments) || this;
    }
    var _proto = BI.prototype;
    _proto.eventStat = function eventStat(key, params) {
      _Core.prototype.eventStat.call(this, key, params);
    };
    _proto.httpGet = function httpGet(url) {
      wx.request({
        url: url
      });
    };
    _proto.getLocalStorage = function getLocalStorage(key) {
      return wx.getStorageSync(key);
    };
    _proto.setLocalStorage = function setLocalStorage(key, value) {
      return wx.setStorageSync(key, value);
    };
    _proto.getSessionStorage = function getSessionStorage(key) {
      return biSession[key];
    };
    _proto.setSessionStorage = function setSessionStorage(key, value) {
      return biSession[key] = value;
    };
    _proto.getOS = function getOS() {
      var systemInfo = wx.getSystemInfoSync();
      var system = systemInfo.system;
      var androidReg = /android/gi;
      var iosReg = /iOS/;
      var type = IOSType.OTHER;
      if (androidReg.test(system)) {
        type = IOSType.ANDROID;
      } else if (iosReg.test(system)) {
        type = IOSType.IOS;
      }
      return type;
    };
    _proto.getPlatform = function getPlatform() {
      // 固定输出miniprogram
      return IPlatpormType.MINIPROGRAM;
    };
    _proto.getPageUrl = function getPageUrl() {
      var pageList = getCurrentPages();
      var pageLen = pageList.length;
      var currentPage = pageList[pageLen - 1];
      return currentPage == null ? void 0 : currentPage.route;
    };
    _proto.getScreen = function getScreen() {
      var _wx$getSystemInfoSync = wx.getSystemInfoSync(),
        screenWidth = _wx$getSystemInfoSync.screenWidth,
        screenHeight = _wx$getSystemInfoSync.screenHeight;
      return screenWidth + "x" + screenHeight;
    };
    return BI;
  }(Core);

  return BI;

}));
}(biSdkMinipro_min));

var BI = biSdkMinipro_min.exports;

var isMp = false;
/** bi 上报实例 */

var bi$1;
/**
 * 初始化 ppd-bi-sdk，鉴权
 */

var initMpBi = function initMpBi(options) {
  var sid = options.sid,
      cid = options.cid,
      beforeReport = options.beforeReport,
      shouldReport = options.shouldReport,
      _options$isDev = options.isDev,
      isDev = _options$isDev === void 0 ? false : _options$isDev;
  bi$1 = new BI({
    sid: sid,
    cid: cid,
    beforeReport: beforeReport,
    shouldReport: shouldReport,
    isDev: isDev
  });
  return bi$1;
};
/**
 * 记录isMp
 */

function setIsMp(inIsMp) {
  isMp = !!inIsMp;
}
/**
 * 获取是否isMp
 */

function getIsMp() {
  return isMp;
}
/**
 * 调用 ppd-bi-sdk 上报
 * @param tag 上报字段, 三段组合
 * @param ext 扩展字段
 */

function defaultReport$1(tag) {
  var ext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  debug('### defaultReport ###', tag, ext);
  bi$1.eventStat(tag, _objectSpread2(_objectSpread2({}, getDynamicParams$1()), ext));
}

var reportMethod$1 = defaultReport$1;
/**
 * 注入上报方法
 * @description 提供这个方法，是为了考虑如下两种情况
 * 1、上报的基础字段，跟bi-sdk里设定的不一样
 * 2、在上报bi的同时，还想做些其它事，诸如：也上报一份到elk或其它行为
 * @param {Function} reportAdapter 上报方法
 * @param {boolean} isKeepDefaultRerport 是否用默认的上报方法。true时，调用默认方法上报bi的同时，执行reportAdatper；相当于做一些额外的工作
 */

function injectMpReportMethod(reportAdapter) {
  var isKeepDefaultRerport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (isKeepDefaultRerport) {
    reportMethod$1 = function reportMethod(tag) {
      var ext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      defaultReport$1(tag, ext);
      reportAdapter(tag, ext);
    };
  } else {
    reportMethod$1 = reportAdapter;
  }
}
/**
 * 获取上报方法
 * @returns
 */

function getMpReportMethod() {
  return reportMethod$1;
}
/**
 * 获取动态的基础字段，在每次上报时都会更新
 */

var getDynamicParams$1 = function getDynamicParams() {
  var _location;

  return {
    fpathname: (_location = location) === null || _location === void 0 ? void 0 : _location.pathname,
    ftime: new Date().getTime()
  };
};

function createTask(task) {
  var resolve = function resolve() {};

  var promise = new Promise(function (res) {
    if (typeof task === 'function') {
      task();
    }

    resolve = res;
  });
  return {
    resolve: resolve,
    promise: promise
  };
}

/** bi 上报实例 */

var bi;
/**
 * 初始化 ppd-bi-sdk，鉴权
 */

var initBi = function initBi(options) {
  var sid = options.sid,
      cid = options.cid,
      beforeReport = options.beforeReport,
      shouldReport = options.shouldReport,
      _options$isUseBeacon = options.isUseBeacon,
      isUseBeacon = _options$isUseBeacon === void 0 ? false : _options$isUseBeacon,
      _options$postReportUr = options.postReportUrl,
      postReportUrl = _options$postReportUr === void 0 ? '' : _options$postReportUr,
      _options$isDev = options.isDev,
      isDev = _options$isDev === void 0 ? false : _options$isDev;
  bi = new BI$1({
    sid: sid,
    cid: cid,
    beforeReport: beforeReport,
    shouldReport: shouldReport,
    isDev: isDev,
    isUseBeacon: isUseBeacon,
    postReportUrl: postReportUrl
  }); // 设置bi上报基础字段

  bi.setDynamicInfo(getBaseParams());
  return bi;
};
/**
 * 调用 ppd-bi-sdk 上报
 * @param tag 上报字段, 三段组合
 * @param ext 扩展字段
 */

function defaultReport(tag) {
  var ext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  debug('### defaultReport ###', tag, ext);
  bi.eventStat(tag, _objectSpread2(_objectSpread2({}, getDynamicParams()), ext));
}

var reportMethod = defaultReport;
/**
 * 注入上报方法
 * @description 提供这个方法，是为了考虑如下两种情况
 * 1、上报的基础字段，跟bi-sdk里设定的不一样
 * 2、在上报bi的同时，还想做些其它事，诸如：也上报一份到elk或其它行为
 * @param {Function} reportAdapter 上报方法
 * @param {boolean} isKeepDefaultRerport 是否用默认的上报方法。true时，调用默认方法上报bi的同时，执行reportAdatper；相当于做一些额外的工作
 */

function injectReportMethod(reportAdapter) {
  var isKeepDefaultRerport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (isKeepDefaultRerport) {
    reportMethod = function reportMethod(tag) {
      var ext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      defaultReport(tag, ext);
      reportAdapter(tag, ext);
    };
  } else {
    reportMethod = reportAdapter;
  }
}
/**
 * 获取上报方法
 * @returns
 */

function getReportMethod() {
  return reportMethod;
}
/**
 * 获取bi上报的基础字段
 * 这些基础字段为常量，在应用的生命周期恒定不变
 */

var getBaseParams = function getBaseParams() {
  var osInfo = getOSInfoObj();
  return {
    fuin: getUin(),
    fopenid: getFuin(),
    fsource: getGlobalConfig().project,
    fadtag: getParamAdtag(),
    fhost: location.host,
    fos: osInfo.type,
    fosver: osInfo.version,
    fclientver: getWeixinVer(),
    flanguage: (getLanguage() || '').replace('-', '_')
  };
};
/**
 * 获取动态的基础字段，在每次上报时都会更新
 */


var getDynamicParams = function getDynamicParams() {
  return {
    fpathname: location.pathname,
    ftime: new Date().getTime()
  };
};

var uinTask = createTask();
/**
 *
 * 暴露的 BI 上报方法
 * @param tag  上报的元素名称，即上报字段 A.B.C 的 C或B.C 部分。
 * @param options 上报参数
 */

function biHotTagReport(_x, _x2) {
  return _biHotTagReport.apply(this, arguments);
}

function _biHotTagReport() {
  _biHotTagReport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(tag, options) {
    var ext,
        _getGlobalConfig,
        reportAfterUin,
        type,
        _options$componentTag,
        componentTag,
        customPageName,
        _getGlobalConfig2,
        group,
        project,
        pageName,
        A,
        BC,
        reportMethod,
        _args = arguments;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ext = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            _getGlobalConfig = getGlobalConfig(), reportAfterUin = _getGlobalConfig.reportAfterUin;

            if (!reportAfterUin) {
              _context.next = 6;
              break;
            }

            if (ext.fuin || ext.fopenid) {
              uinTask.resolve();
            }

            _context.next = 6;
            return uinTask.promise;

          case 6:
            // 检查各个层级的字段是否为空，为空则报错
            type = options.type, _options$componentTag = options.componentTag, componentTag = _options$componentTag === void 0 ? DEFAULT_COMPONENT_TAG : _options$componentTag, customPageName = options.customPageName;
            _getGlobalConfig2 = getGlobalConfig(), group = _getGlobalConfig2.group, project = _getGlobalConfig2.project;
            pageName = mapFunc(customPageName) || getPageName();

            if (!(!group || !project)) {
              _context.next = 11;
              break;
            }

            throw '请引入上报组件时定义 gruop 及 project，以区分不同的项目';

          case 11:
            if (pageName) {
              _context.next = 13;
              break;
            }

            throw '请给当前路由声明name属性，以区分不同页面';

          case 13:
            checkExtIfStartWitfF(ext, tag); // 校验扩展字段是否以f开头
            // 生成上报事件

            A = formatPageKey(group, project, pageName);
            BC = tag;

            if (!/^[a-zA-Z0-9\-_]+\.[a-zA-Z0-9\-_]+/.test(BC)) {
              // 如果只有C，那么用组件名称补上
              BC = "".concat(componentTag, ".").concat(tag);
            }

            reportMethod = getIsMp() ? getMpReportMethod : getReportMethod;
            reportMethod()("".concat(A, ".").concat(BC), _objectSpread2({
              faction: type
            }, Object.assign({
              findex: 0
            }, ext)));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _biHotTagReport.apply(this, arguments);
}
/**
 * 校验扩展字段，必须以f开头
 */

var checkExtIfStartWitfF = function checkExtIfStartWitfF(ext, tag) {
  if (getGlobalConfig().closeCheckExtF) {
    return;
  }

  var errors = [];
  var keys = Object.keys(ext);
  keys.forEach(function (key) {
    if (!/^f.+/.test(key)) {
      errors.push(key);
    }
  });

  if (errors.length > 0) {
    throw "\u57CB\u70B9[".concat(tag, "]\u6240\u643A\u5E26\u7684\u6269\u5C55\u5B57\u6BB5[").concat(errors.join(','), "]\u547D\u540D\u5FC5\u987B\u4EE5f\u5F00\u5934\uFF0C\u8BF7\u66F4\u6B63");
  }
};
/**
 * 点击上报
 */


function biClick(tag) {
  var ext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _tag$split = tag.split(/[\||｜]/),
      _tag$split2 = _slicedToArray(_tag$split, 1),
      BC = _tag$split2[0]; // 支持半角竖线


  biHotTagReport(BC, {
    type: exports.Operation.CLICK
  }, ext);
}
/**
 * 曝光上报
 */

function biBrow(tag) {
  var ext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _tag$split3 = tag.split(/[\||｜]/),
      _tag$split4 = _slicedToArray(_tag$split3, 1),
      BC = _tag$split4[0]; // 支持半角竖线


  biHotTagReport(BC, {
    type: exports.Operation.BROW
  }, ext);
}

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function() {

// Exit early if we're not running in a browser.
if (typeof window !== 'object') {
  return;
}

// Exit early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}

/**
 * Returns the embedding frame element, if any.
 * @param {!Document} doc
 * @return {!Element}
 */
function getFrameElement(doc) {
  try {
    return doc.defaultView && doc.defaultView.frameElement || null;
  } catch (e) {
    // Ignore the error.
    return null;
  }
}

/**
 * A local reference to the root document.
 */
var document = (function(startDoc) {
  var doc = startDoc;
  var frame = getFrameElement(doc);
  while (frame) {
    doc = frame.ownerDocument;
    frame = getFrameElement(doc);
  }
  return doc;
})(window.document);

/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];

/**
 * The signal updater for cross-origin intersection. When not null, it means
 * that the polyfill is configured to work in a cross-origin mode.
 * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
var crossOriginUpdater = null;

/**
 * The current cross-origin intersection. Only used in the cross-origin mode.
 * @type {DOMRect|ClientRect}
 */
var crossOriginRect = null;


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = ensureDOMRect(entry.rootBounds);
  this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
  this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (
    options.root &&
    options.root.nodeType != 1 &&
    options.root.nodeType != 9
  ) {
    throw new Error('root must be a Document or Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');

  /** @private @const {!Array<!Document>} */
  this._monitoringDocuments = [];
  /** @private @const {!Array<function()>} */
  this._monitoringUnsubscribes = [];
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Sets up the polyfill in the cross-origin mode. The result is the
 * updater function that accepts two arguments: `boundingClientRect` and
 * `intersectionRect` - just as these fields would be available to the
 * parent via `IntersectionObserverEntry`. This function should be called
 * each time the iframe receives intersection information from the parent
 * window, e.g. via messaging.
 * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
IntersectionObserver._setupCrossOriginUpdater = function() {
  if (!crossOriginUpdater) {
    /**
     * @param {DOMRect|ClientRect} boundingClientRect
     * @param {DOMRect|ClientRect} intersectionRect
     */
    crossOriginUpdater = function(boundingClientRect, intersectionRect) {
      if (!boundingClientRect || !intersectionRect) {
        crossOriginRect = getEmptyRect();
      } else {
        crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
      }
      registry.forEach(function(observer) {
        observer._checkForIntersections();
      });
    };
  }
  return crossOriginUpdater;
};


/**
 * Resets the cross-origin mode.
 */
IntersectionObserver._resetCrossOriginUpdater = function() {
  crossOriginUpdater = null;
  crossOriginRect = null;
};


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections(target.ownerDocument);
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {
        return item.element != target;
      });
  this._unmonitorIntersections(target.ownerDocument);
  if (this._observationTargets.length == 0) {
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorAllIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function(doc) {
  var win = doc.defaultView;
  if (!win) {
    // Already destroyed.
    return;
  }
  if (this._monitoringDocuments.indexOf(doc) != -1) {
    // Already monitoring.
    return;
  }

  // Private state for monitoring.
  var callback = this._checkForIntersections;
  var monitoringInterval = null;
  var domObserver = null;

  // If a poll interval is set, use polling instead of listening to
  // resize and scroll events or DOM mutations.
  if (this.POLL_INTERVAL) {
    monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
  } else {
    addEvent(win, 'resize', callback, true);
    addEvent(doc, 'scroll', callback, true);
    if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
      domObserver = new win.MutationObserver(callback);
      domObserver.observe(doc, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  this._monitoringDocuments.push(doc);
  this._monitoringUnsubscribes.push(function() {
    // Get the window object again. When a friendly iframe is destroyed, it
    // will be null.
    var win = doc.defaultView;

    if (win) {
      if (monitoringInterval) {
        win.clearInterval(monitoringInterval);
      }
      removeEvent(win, 'resize', callback, true);
    }

    removeEvent(doc, 'scroll', callback, true);
    if (domObserver) {
      domObserver.disconnect();
    }
  });

  // Also monitor the parent.
  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;
  if (doc != rootDoc) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._monitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function(doc) {
  var index = this._monitoringDocuments.indexOf(doc);
  if (index == -1) {
    return;
  }

  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;

  // Check if any dependent targets are still remaining.
  var hasDependentTargets =
      this._observationTargets.some(function(item) {
        var itemDoc = item.element.ownerDocument;
        // Target is in this context.
        if (itemDoc == doc) {
          return true;
        }
        // Target is nested in this context.
        while (itemDoc && itemDoc != rootDoc) {
          var frame = getFrameElement(itemDoc);
          itemDoc = frame && frame.ownerDocument;
          if (itemDoc == doc) {
            return true;
          }
        }
        return false;
      });
  if (hasDependentTargets) {
    return;
  }

  // Unsubscribe.
  var unsubscribe = this._monitoringUnsubscribes[index];
  this._monitoringDocuments.splice(index, 1);
  this._monitoringUnsubscribes.splice(index, 1);
  unsubscribe();

  // Also unmonitor the parent.
  if (doc != rootDoc) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._unmonitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorAllIntersections = function() {
  var unsubscribes = this._monitoringUnsubscribes.slice(0);
  this._monitoringDocuments.length = 0;
  this._monitoringUnsubscribes.length = 0;
  for (var i = 0; i < unsubscribes.length; i++) {
    unsubscribes[i]();
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  if (!this.root && crossOriginUpdater && !crossOriginRect) {
    // Cross origin monitoring, but no initial data available yet.
    return;
  }

  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, targetRect, rootRect);

    var rootBounds = null;
    if (!this._rootContainsTarget(target)) {
      rootBounds = getEmptyRect();
    } else if (!crossOriginUpdater || this.root) {
      rootBounds = rootRect;
    }

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootBounds,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} targetRect The bounding rect of the target.
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, targetRect, rootRect) {
  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot && parent) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return null;

    if (parent == this.root || parent.nodeType == /* DOCUMENT */ 9) {
      atRoot = true;
      if (parent == this.root || parent == document) {
        if (crossOriginUpdater && !this.root) {
          if (!crossOriginRect ||
              crossOriginRect.width == 0 && crossOriginRect.height == 0) {
            // A 0-size cross-origin intersection means no-intersection.
            parent = null;
            parentRect = null;
            intersectionRect = null;
          } else {
            parentRect = crossOriginRect;
          }
        } else {
          parentRect = rootRect;
        }
      } else {
        // Check if there's a frame that can be navigated to.
        var frame = getParentNode(parent);
        var frameRect = frame && getBoundingClientRect(frame);
        var frameIntersect =
            frame &&
            this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
        if (frameRect && frameIntersect) {
          parent = frame;
          parentRect = convertFromParentRect(frameRect, frameIntersect);
        } else {
          parent = null;
          intersectionRect = null;
        }
      }
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      var doc = parent.ownerDocument;
      if (parent != doc.body &&
          parent != doc.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);
    }
    if (!intersectionRect) break;
    parent = parent && getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {ClientRect} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root && !isDoc(this.root)) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var doc = isDoc(this.root) ? this.root : document;
    var html = doc.documentElement;
    var body = doc.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {DOMRect|ClientRect} rect The rect object to expand.
 * @return {ClientRect} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;
  return (
    containsDeep(rootDoc, target) &&
    (!this.root || rootDoc == target.ownerDocument)
  );
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detatchEvent == 'function') {
    node.detatchEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object|?ClientRect} The intersection rect or undefined if no
 *     intersection is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  } || null;
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {ClientRect} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}


/**
 * Ensure that the result has all of the necessary fields of the DOMRect.
 * Specifically this ensures that `x` and `y` fields are set.
 *
 * @param {?DOMRect|?ClientRect} rect
 * @return {?DOMRect}
 */
function ensureDOMRect(rect) {
  // A `DOMRect` object has `x` and `y` fields.
  if (!rect || 'x' in rect) {
    return rect;
  }
  // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
  // for internally calculated Rect objects. For the purposes of
  // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
  // for these fields.
  return {
    top: rect.top,
    y: rect.top,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    right: rect.right,
    width: rect.width,
    height: rect.height
  };
}


/**
 * Inverts the intersection and bounding rect from the parent (frame) BCR to
 * the local BCR space.
 * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
 * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
 * @return {ClientRect} The local root bounding rect for the parent's children.
 */
function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
  var top = parentIntersectionRect.top - parentBoundingRect.top;
  var left = parentIntersectionRect.left - parentBoundingRect.left;
  return {
    top: top,
    left: left,
    height: parentIntersectionRect.height,
    width: parentIntersectionRect.width,
    bottom: top + parentIntersectionRect.height,
    right: left + parentIntersectionRect.width
  };
}


/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (node.nodeType == /* DOCUMENT */ 9 && node != document) {
    // If this node is a document node, look for the embedding frame.
    return getFrameElement(node);
  }

  // If the parent has element that is assigned through shadow root slot
  if (parent && parent.assignedSlot) {
    parent = parent.assignedSlot.parentNode;
  }

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }

  return parent;
}

/**
 * Returns true if `node` is a Document.
 * @param {!Node} node
 * @returns {boolean}
 */
function isDoc(node) {
  return node && node.nodeType === 9;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}());

var defaultOptions = {
  rootMargin: '0px',

  /** 默认显示于画面的阈值，可以调节 */
  threshold: 0.3 // 这里需要足够小，如果很长的页面，首屏占全页面暴露的比例很小，这里isIntersecting就会有问题

};
var ExposureObserver = /*#__PURE__*/function () {
  function ExposureObserver(options) {
    _classCallCheck(this, ExposureObserver);

    _defineProperty(this, "eventMap", new Map());

    this.options = _objectSpread2(_objectSpread2({}, defaultOptions), options);
    this.createObserver(this.options);
  }
  /**
   * 监听元素的是否出现于视图中,同一个元素可能被监听两次，比如brow和leave
   * @param target 监听元素
   * @param callback 回调函数
   */


  _createClass(ExposureObserver, [{
    key: "observerTarget",
    value: function observerTarget(target, callback) {
      var _this$eventMap$get$ca, _this$eventMap$get;

      this.observer.observe(target);
      var listeners = (_this$eventMap$get$ca = (_this$eventMap$get = this.eventMap.get(target)) === null || _this$eventMap$get === void 0 ? void 0 : _this$eventMap$get.callbacks) !== null && _this$eventMap$get$ca !== void 0 ? _this$eventMap$get$ca : [];
      this.eventMap.set(target, {
        callbacks: [].concat(_toConsumableArray(listeners), [callback])
      });
    }
    /**
     * 解除监听对象。请在在 componentWillUnmount 或 unbind 中调用，否则会造成内存泄漏
     * @param target 监听对象
     */

  }, {
    key: "unobserveTarget",
    value: function unobserveTarget(target, callback) {
      if (!callback) {
        this.observer.unobserve(target);
        this.eventMap["delete"](target);
      } else {
        // unobserverTarget 是在 oberserver的回调函数里使用，所以listener一定有值。
        var listeners = this.eventMap.get(target).callbacks;
        this.eventMap.set(target, {
          callbacks: listeners.filter(function (cb) {
            return cb !== callback;
          })
        });
      }
    }
  }, {
    key: "createObserver",
    value: function createObserver(options) {
      var _this = this;

      this.destroy();
      this.observer = new IntersectionObserver(function (entires) {
        // 同一个元素在进入视野和离开视野都会触发一次回调函数,可以作为停留时长的计算
        entires.forEach(function (entry) {
          var target = entry.target;

          var observerParams = _this.eventMap.get(target);

          if (observerParams) {
            var callbacks = observerParams.callbacks;
            callbacks.forEach(function (callback) {
              callback(entry);
            });
          }
        });
      }, options);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.observer) {
        this.observer.disconnect();
        this.eventMap.clear();
      }
    }
  }], [{
    key: "getInstance",
    value: function getInstance(options) {
      var forceInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.instance || forceInit) {
        this.instance = new ExposureObserver(options);
      }

      return this.instance;
    }
  }]);

  return ExposureObserver;
}();

function debounce(fn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var that = arguments.length > 2 ? arguments[2] : undefined;
  var timer = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (!that) {
      that = this;
    }

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(function () {
      fn.apply(that, args);
    }, delay);
  };
}

var HeatMap = /*#__PURE__*/function () {
  function HeatMap(el, row, column) {
    _classCallCheck(this, HeatMap);

    this.el = el;
    this.row = row;
    this.column = column;
    this.updatePosition();
  }

  _createClass(HeatMap, [{
    key: "updatePosition",
    value: function updatePosition() {
      var _this$el$getBoundingC = this.el.getBoundingClientRect(),
          x = _this$el$getBoundingC.x,
          y = _this$el$getBoundingC.y,
          width = _this$el$getBoundingC.width,
          height = _this$el$getBoundingC.height;

      this.elementPosition = {
        leftTop: [x, y],
        leftBottom: [x, y + height],
        rightTop: [x + width, y],
        rightBottom: [x + width, y + height]
      };
      this.x = x;
      this.y = y;
      this.width = width;
      this.height = height;
    }
  }, {
    key: "clickStatistics",
    value: function clickStatistics(x, y) {
      var pos = this.elementPosition;

      if (x > pos.rightBottom[0] || y > pos.rightBottom[1] || x < pos.leftBottom[0] || y < pos.leftTop[1]) {
        return [-1, -1];
      }

      var partitionY = this.height / this.row;
      var partitionX = this.width / this.column;
      var xIndex = Math.ceil((x - this.x) / partitionX) || 1; // 边界值0相当于第一格

      var yIndex = Math.ceil((y - this.y) / partitionY) || 1; // 边界值0相当于第一格

      return [yIndex, xIndex];
    }
  }]);

  return HeatMap;
}();

/** 是否是一个普通对象 */
function isObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}
/** 是否含有某个 key */

function hasKey(obj, key) {
  return key in obj;
}

/**
 * 初始化 Directive 组件
 * 支持通过 v-stat:click 或 v-stat.click.brow 使用
 * @param app Vue 实例
 */

var initDirective = function initDirective(app, getPageNameFn) {
  app.directive('stat', {
    // vu2 syntax
    bind: function bind(el, binding) {
      bindLazyHandler(el, binding); // @ts-ignore

      el.$value = binding.value; // @ts-ignore

      el.$pageName = getPageNameFn();
      bindHanlder(el, binding);
    },
    unbind: function unbind(el) {
    },
    componentUpdated: function componentUpdated(el, binding) {
      // @ts-ignore
      el.$value = binding.value;
      updatedLazyHandler(el, binding);
    },
    // vu3 syntax
    beforeMount: function beforeMount(el, binding) {
      bindLazyHandler(el, binding); // @ts-ignore

      el.$value = binding.value; // @ts-ignore

      el.$pageName = getPageNameFn();
      bindHanlder(el, binding);
    },
    unmounted: function unmounted(el) {
    },
    updated: function updated(el, binding) {
      // @ts-ignore
      el.$value = binding.value;
      updatedLazyHandler(el, binding);
    }
  });
};
/**
 * 延迟上报
 * @param el
 * @param binding
 */

var bindLazyHandler = function bindLazyHandler(el, binding) {
  // @ts-ignore
  el.$lazyStore = 0; // @ts-ignore

  el.$isLazy = isLazy(binding.arg);
};
/**
 * 延迟上报
 * @param el
 * @param binding
 */


var updatedLazyHandler = function updatedLazyHandler(el, binding) {
  // @ts-ignore
  el.$isLazy = isLazy(binding.arg); // 处理延迟上报

  handleLazyData(el, binding);
};
/**
 * 是否延迟上报
 * @param arg
 */


var isLazy = function isLazy(arg) {
  // 如果指令变量为对象且有isLazy的 key，则优先取变量对象的isLazy
  var argument = isObject(arg) && hasKey(arg, DirectiveParamsKey.isLazy) ? arg.isLazy : arg;
  return argument === false || argument === 0 || argument === null;
};
/**
 * 在updated时，处理延迟上报的数据
 * @param el
 * @param binding
 */


var handleLazyData = function handleLazyData(el, binding) {
  // @ts-ignore
  if (isLazy(binding.arg) || el.$lazyStore <= 0) return; // @ts-ignore

  var lazyStore = el.$lazyStore || 0; // @ts-ignore

  var _analysisDirectiveVal = analysisDirectiveValue(el.$value),
      key = _analysisDirectiveVal.key,
      ext = _analysisDirectiveVal.ext; // analysisDataSet是为了兼容data-*属性携带扩展字段的旧模式


  var statExt = ext ? ext : analysisDataSet(el.dataset);

  for (var i = 0; i < lazyStore; i++) {
    biHotTagReport(key, {
      type: exports.Operation.BROW,
      componentTag: ComponentTag.TEMPLATE,
      // @ts-ignore
      customPageName: el.$pagename
    }, statExt);
  } // 清零
  // @ts-ignore


  el.$lazyStore = 0;
};

var bindHanlder = function bindHanlder(el, binding) {
  // 获取 value - 元素名称
  // arg，modifers 为操作类型，默认为 click
  var arg = binding.arg,
      _binding$modifiers = binding.modifiers,
      modifiers = _binding$modifiers === void 0 ? {} : _binding$modifiers; // 获取操作类型

  var operations = filterOperations(modifiers);

  var _iterator = _createForOfIteratorHelper(operations),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var operation = _step.value;

      // 操作类型为click：则监听元素点击事件
      switch (operation) {
        case exports.Operation.CLICK:
          handleClick(el);
          break;

        case exports.Operation.BROW:
          // 如果指令变量为对象且有isMultBrowy的 key，则根据isMultBrow的值判断是否重复曝光上报
          isObject(arg) && hasKey(arg, DirectiveParamsKey.isMultBrow) && arg.isMultBrow ? handlerMutilpleBrow(el) : handlerBrow(el);
          break;

        case exports.Operation.BROW_MULT:
          handlerMutilpleBrow(el);
          break;

        case exports.Operation.LEAVE:
          handleNavigation(el);
          break;

        case exports.Operation.SCROLL:
          handleScroll(el);
          break;

        case exports.Operation.HEAT_MAP:
          handleHeatMap(el);
          break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
/**
 * 获取操作类型数组
 * @param modifiers modifers 为对象, 例如 {click: true, brow: true}
 * @returns
 */


var filterOperations = function filterOperations(modifiers) {
  var operations = new Set(); // 从 modifers 中获取 key 值

  if (modifiers) {
    for (var _i = 0, _Object$keys = Object.keys(modifiers); _i < _Object$keys.length; _i++) {
      var keys = _Object$keys[_i];

      if (modifiers[keys]) {
        operations.add(keys);
      }
    }
  } // 若未定义modifers，默认为 click 事件


  if (operations.size === 0) {
    operations.add(DEFAULT_OPERATION);
  } // 如果同时有Operation.BROW和Operation.BROW_MULT，则只保留BROW_MULT


  if (operations.has(exports.Operation.BROW) && operations.has(exports.Operation.BROW_MULT)) {
    operations["delete"](exports.Operation.BROW);
  }

  return Array.from(operations);
};
/**
 * 解析指令上报内容
 * 埋点说明部分通过竖线分割
 * 返回：{key:'B.C',ext:'扩展字段对象'}
 * @param value
 * @returns
 */


var analysisDirectiveValue = function analysisDirectiveValue(value) {
  var key = '',
      ext = undefined;

  if (typeof value === 'string') {
    var _value$split = value.split(/[\||｜]/);

    var _value$split2 = _slicedToArray(_value$split, 1);

    key = _value$split2[0];
  } else {
    var _value$tag$split = value.tag.split(/[\||｜]/);

    var _value$tag$split2 = _slicedToArray(_value$tag$split, 1);

    key = _value$tag$split2[0];
    // 支持半角竖线
    ext = value.ext;
  }

  return {
    key: key,
    ext: ext
  };
};
/**
 * 解析扩展字段（data-stat-ext*携带的对象
 */

var analysisDataSet = function analysisDataSet(dataset) {
  // statExt对应data-stat-ext
  // statext对应data-statext和data-statExt
  // stat_ext对应data-stat_ext
  // stat对应data-stat
  var _dataset$statExt = dataset.statExt,
      statExt = _dataset$statExt === void 0 ? '{}' : _dataset$statExt,
      _dataset$statext = dataset.statext,
      statext = _dataset$statext === void 0 ? '{}' : _dataset$statext,
      _dataset$stat_ext = dataset.stat_ext,
      stat_ext = _dataset$stat_ext === void 0 ? '{}' : _dataset$stat_ext,
      _dataset$stat = dataset.stat,
      stat = _dataset$stat === void 0 ? '{}' : _dataset$stat;
  var ext = {};

  try {
    ext = Object.assign({}, JSON.parse(statExt), JSON.parse(statext), JSON.parse(stat_ext), JSON.parse(stat));
  } catch (e) {
    console.error(e);
    throw '解析data-stat失败。data属性值必须是字符串，可以JSON.stringify()序列化';
  }

  return ext;
};
/**
 * 处理点击上报事件
 * @param el 绑定元素
 * @param value directive value，例如: "newOrder|点击最新订单"
 */

var handleClick = function handleClick(el) {
  var handler = function handler() {
    // @ts-ignore
    var _analysisDirectiveVal2 = analysisDirectiveValue(el.$value),
        key = _analysisDirectiveVal2.key,
        ext = _analysisDirectiveVal2.ext; // analysisDataSet是为了兼容data-*属性携带扩展字段的旧模式


    var statExt = ext ? ext : analysisDataSet(el.dataset);
    biHotTagReport(key, {
      type: exports.Operation.CLICK,
      componentTag: ComponentTag.TEMPLATE,
      // @ts-ignore
      customPageName: el.$pageName
    }, statExt);
  };

  el.addEventListener('click', handler, true); // 注意：要用捕获事件(true)，使得addEventListener绑定的事件 优先于 v-on绑定的事件执行
  // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听

  el.__vueHottagClick__ = handler;
};
/**
 * 处理曝光事件，触发曝光后解除监听，同一元素最多触发一次
 * @param el 绑定元素
 * @param value directive value，例如: "newOrder|点击最新订单"
 */


var handlerBrow = function handlerBrow(el) {
  var observer = ExposureObserver.getInstance();

  var browCallback = function browCallback(change) {
    if (change.isIntersecting) {
      // 如果是lazy模式，先入库，然后在updated中检测并上报
      // @ts-ignore
      if (el.$isLazy) {
        // @ts-ignore
        el.$lazyStore += 1;
        return;
      } // @ts-ignore


      var _analysisDirectiveVal3 = analysisDirectiveValue(el.$value),
          key = _analysisDirectiveVal3.key,
          ext = _analysisDirectiveVal3.ext; // analysisDataSet是为了兼容data-*属性携带扩展字段的旧模式


      var statExt = ext ? ext : analysisDataSet(el.dataset);
      biHotTagReport(key, {
        type: exports.Operation.BROW,
        componentTag: ComponentTag.TEMPLATE,
        // @ts-ignore
        customPageName: el.$pageName
      }, statExt);
      observer.unobserveTarget(el, browCallback);
    }
  };

  observer.observerTarget(el, browCallback);
};
/**
 * 处理曝光事件，元素首次出现或再次出现在视图中都会触发。
 * @param el 绑定元素
 * @param value directive value，例如: "newOrder|点击最新订单"
 */


var handlerMutilpleBrow = function handlerMutilpleBrow(el) {
  var observer = ExposureObserver.getInstance();
  observer.observerTarget(el, function (change) {
    if (change.isIntersecting) {
      // 如果是lazy模式，先入库，然后在updated中检测并上报
      // @ts-ignore
      if (el.$isLazy) {
        // @ts-ignore
        el.$lazyStore += 1;
        return;
      } // @ts-ignore


      var _analysisDirectiveVal4 = analysisDirectiveValue(el.$value),
          key = _analysisDirectiveVal4.key,
          ext = _analysisDirectiveVal4.ext; // analysisDataSet是为了兼容data-*属性携带扩展字段的旧模式


      var statExt = ext ? ext : analysisDataSet(el.dataset);
      biHotTagReport(key, {
        type: exports.Operation.BROW,
        componentTag: ComponentTag.TEMPLATE,
        // @ts-ignore
        customPageName: el.$pagename
      }, statExt);
    }
  });
};
/**
 * 处理停留时间上报的页面跳转事件，同一元素可以触发多次
 * @param el 绑定元素
 */


function handleNavigation(ele) {
  var _getGlobalConfig$rout;

  // 此功能需要使用routeChangeListen这个方法先监听页面跳转
  // 或者在下面用router.beforeEach带上onRouteChange中的处理函数
  var observer = ExposureObserver.getInstance();
  var observerPage = '';
  observer.observerTarget(ele, function (change) {
    if (change.isIntersecting) {
      observerPage = getHash();
      ele.setAttribute('time', "".concat(new Date().getTime()));
    } else {
      var _ele$getAttribute;

      var timeAttr = (_ele$getAttribute = ele.getAttribute('time')) !== null && _ele$getAttribute !== void 0 ? _ele$getAttribute : '-1';
      var time = parseInt(timeAttr, 10);

      if (time !== -1) {
        // 元素消失
        var _analysisDirectiveVal5 = analysisDirectiveValue(ele.$value),
            key = _analysisDirectiveVal5.key,
            ext = _analysisDirectiveVal5.ext; // analysisDataSet是为了兼容data-*属性携带扩展字段的旧模式


        var statExt = ext ? ext : analysisDataSet(ele.dataset);
        var fstaytime = new Date().getTime() - time;
        biHotTagReport(key, {
          type: exports.Operation.LEAVE,
          componentTag: ComponentTag.TEMPLATE,
          // @ts-ignore
          customPageName: ele.$pagename
        }, _objectSpread2({
          fstay_time: fstaytime
        }, statExt));
      }
    }
  }); // vue-router 上报的是 customPageName：route.name

  var routeFromName = '';

  var navigationListener = function navigationListener(from, to) {
    var _ele$getAttribute2;

    var timeAttr = (_ele$getAttribute2 = ele.getAttribute('time')) !== null && _ele$getAttribute2 !== void 0 ? _ele$getAttribute2 : '-1';
    var time = parseInt(timeAttr, 10);

    if (from === observerPage && to !== observerPage && time !== -1) {
      // 满足from是元素的页面，to是其他页面，且元素出现在页面上过
      // 更新路由即将变化的页面时间
      ele.removeAttribute('time');
      var routeChangeTime = new Date().getTime(); // 元素已经出现在视野中了，可以计算停留时长上报

      var fstaytime = routeChangeTime - time;
      fstaytime = fstaytime > 0 ? fstaytime : 0; // @ts-ignore

      var _analysisDirectiveVal6 = analysisDirectiveValue(ele.$value),
          key = _analysisDirectiveVal6.key,
          ext = _analysisDirectiveVal6.ext; // analysisDataSet是为了兼容data-*属性携带扩展字段的旧模式


      var statExt = ext ? ext : analysisDataSet(ele.dataset);
      biHotTagReport(key, {
        type: exports.Operation.LEAVE,
        componentTag: ComponentTag.TEMPLATE,
        customPageName: routeFromName || from.slice(1)
      }, _objectSpread2({
        fstay_time: fstaytime
      }, statExt));
    }
  };

  onRouteChange(navigationListener, false); // vue-router 路由监听处理

  (_getGlobalConfig$rout = getGlobalConfig().route) === null || _getGlobalConfig$rout === void 0 ? void 0 : _getGlobalConfig$rout.beforeEach(function (to, from, next) {
    // 来源记录
    routeFromName = from.name; // 处理切换路由的页面停留时间

    navigationListener("#".concat(from.path), "#".concat(to.path)); // 重置来源

    routeFromName = ''; // 页面跳转

    next();
  });
}
/**
 * 处理组件或者页面的滑动事件，同一元素可以触发多次
 * @param ele 绑定元素
 */


function handleScroll(ele) {
  var _ele$dataset$ref, _refEle$scrollHeight;

  var refEle = document.querySelector((_ele$dataset$ref = ele.dataset.ref) !== null && _ele$dataset$ref !== void 0 ? _ele$dataset$ref : 'body');
  var refHeight = (_refEle$scrollHeight = refEle === null || refEle === void 0 ? void 0 : refEle.scrollHeight) !== null && _refEle$scrollHeight !== void 0 ? _refEle$scrollHeight : window.screen.height;
  var scrollY = 0;
  var isScrolling = false;
  var scrollPosition = {
    scrollY: 0
  };

  var scrollListener = function scrollListener(e) {
    var _ele$dataset$scrollTh, _ele$dataset$scrollRa;

    isScrolling = false;
    var scrollThreshold = +((_ele$dataset$scrollTh = ele.dataset['scrollThreshold']) !== null && _ele$dataset$scrollTh !== void 0 ? _ele$dataset$scrollTh : 10); // 滑动阈值

    var scrollRatio = +((_ele$dataset$scrollRa = ele.dataset['scrollRatio']) !== null && _ele$dataset$scrollRa !== void 0 ? _ele$dataset$scrollRa : 0.03); // 滑动比例

    var _analysisDirectiveVal7 = analysisDirectiveValue(ele.$value),
        key = _analysisDirectiveVal7.key,
        ext = _analysisDirectiveVal7.ext;

    var statExt = ext ? ext : analysisDataSet(ele.dataset);
    var elementTag = ComponentTag.TEMPLATE;
    var targetEle = e.target;
    scrollY = targetEle.scrollTop; // scrollX = targetEle!.scrollLeft;

    var fscnum = scrollY / refHeight;
    var fscper = scrollY / document.body.scrollHeight;
    var diff = Math.abs(scrollPosition.scrollY - scrollY);

    if (diff > scrollThreshold || diff / document.body.scrollHeight > scrollRatio) {
      biHotTagReport(key, {
        type: exports.Operation.SCROLL,
        componentTag: elementTag,
        // @ts-ignore
        customPageName: ele.$pagename
      }, _objectSpread2(_objectSpread2({}, statExt), {}, {
        fscnum: fscnum,
        fscper: fscper
      }));
    }

    scrollPosition.scrollY = scrollY;
  };

  var debounceScrollListener = debounce(scrollListener, 200, ele);
  ele.addEventListener('scroll', function (e) {
    debounceScrollListener(e);
    isScrolling = true;
  }, {
    capture: true,
    passive: true
  }); // 当元素正在滑动，突然切换tab、弹窗或者关掉页面的时候上报占屏比。也就是元素消失或者页面切换或者关闭的时候上报占屏比，出现概率很小

  var observer = ExposureObserver.getInstance();
  observer.observerTarget(ele, function (change) {
    if (!change.isIntersecting && isScrolling) {
      // 元素离开视野
      debug('上报占屏比');

      var _analysisDirectiveVal8 = analysisDirectiveValue(ele.$value),
          key = _analysisDirectiveVal8.key,
          ext = _analysisDirectiveVal8.ext;

      var statExt = ext ? ext : analysisDataSet(ele.dataset);
      var elementTag = ComponentTag.TEMPLATE;
      var fscnum = scrollY / refHeight;
      var fscper = scrollY / document.body.scrollHeight;
      biHotTagReport(key, {
        type: exports.Operation.SCROLL,
        componentTag: elementTag,
        // @ts-ignore
        customPageName: ele.$pagename
      }, _objectSpread2(_objectSpread2({}, statExt), {}, {
        fscnum: fscnum,
        fscper: fscper
      }));
    }
  });
  onRouteChange(function () {
    // 页面切换
    if (isScrolling) {
      var _analysisDirectiveVal9 = analysisDirectiveValue(ele.$value),
          key = _analysisDirectiveVal9.key,
          ext = _analysisDirectiveVal9.ext;

      var statExt = ext ? ext : analysisDataSet(ele.dataset);
      var elementTag = ComponentTag.TEMPLATE;
      var fscnum = scrollY / window.screen.height;
      var fscper = scrollY / document.body.scrollHeight;
      biHotTagReport(key, {
        type: exports.Operation.SCROLL,
        componentTag: elementTag,
        // @ts-ignore
        customPageName: ele.$pagename
      }, _objectSpread2(_objectSpread2({}, statExt), {}, {
        fscnum: fscnum,
        fscper: fscper
      }));
    }
  }, true);
}
/**
 * 处理组件或者页面的热力图上报
 * @param ele 绑定元素
 */


function handleHeatMap(ele) {
  var hmConfig = getHmConfig(ele);
  var observer = ExposureObserver.getInstance();
  var hm = new HeatMap(ele, hmConfig.row, hmConfig.column);

  var initHeatMap = function initHeatMap(change) {
    if (change.isIntersecting) {
      setTimeout(function () {
        // 弹窗有动画效果，所以el的位置可能会发生变化，等移动停止后再开始初始化热力图
        hm = new HeatMap(ele, hmConfig.row, hmConfig.column);
        observer.unobserveTarget(ele, initHeatMap);
      }, hmConfig.animateDurationTime);
    }
  };

  var updatePos = function updatePos() {
    // 针对能滑动的热力图要时刻更新位置信息，否则热力图的点位会算错
    hm.updatePosition();
  };

  window.addEventListener('scroll', debounce(updatePos, 20), {
    capture: true,
    passive: true
  });
  observer.observerTarget(ele, initHeatMap);
  ele.addEventListener('click', function (e) {
    hmConfig = getHmConfig(ele);
    hm = new HeatMap(ele, hmConfig.row, hmConfig.column);

    var _hm$clickStatistics = hm.clickStatistics(e.x, e.y),
        _hm$clickStatistics2 = _slicedToArray(_hm$clickStatistics, 2),
        row = _hm$clickStatistics2[0],
        column = _hm$clickStatistics2[1];

    var _analysisDirectiveVal10 = analysisDirectiveValue(ele.$value),
        key = _analysisDirectiveVal10.key,
        ext = _analysisDirectiveVal10.ext;

    var statExt = ext ? ext : analysisDataSet(ele.dataset);
    var elementTag = ComponentTag.TEMPLATE;
    var fclickZone = (row - 1) * hm.column + column;

    if (column > 0 && row > 0) {
      biHotTagReport(key, {
        type: exports.Operation.CLICK,
        componentTag: elementTag,
        // @ts-ignore
        customPageName: ele.$pagename
      }, _objectSpread2(_objectSpread2({}, statExt), {}, {
        fclick_zone: fclickZone
      }));
    } else {
      console.warn('超过边界');
    }
  });
}

function getHmConfig(ele) {
  var hmConfig;

  try {
    hmConfig = JSON.parse(ele.dataset.hmConfig);
    hmConfig = ensureHeatMap(hmConfig);
  } catch (error) {
    console.error('请在data-hm-config的值提供行row和列column参数，包裹在JSON对象中');
  }

  return hmConfig;
}

function ensureHeatMap(hmConfig) {
  var copyConfig = _objectSpread2({}, hmConfig);

  if (!copyConfig.animateDurationTime) {
    copyConfig.animateDurationTime = 0;
  }

  if (!copyConfig.column) {
    throw '请提供column参数';
  }

  if (!copyConfig.row) {
    throw '请提供row参数';
  }

  return copyConfig;
}

function currentPageRoute() {
  var _curPage$route;

  // @ts-ignore
  var pages = getCurrentPages();

  if (!pages || pages.length === 0) {
    return '';
  }

  var curPage = pages[pages.length - 1];
  return (_curPage$route = curPage === null || curPage === void 0 ? void 0 : curPage.route) !== null && _curPage$route !== void 0 ? _curPage$route : 'miniprogramPlugin';
}

var _wx;
var pageLevelReportMap = new WeakMap();
var globalComponentReportSet = new Set();
var MpReport = /*#__PURE__*/function () {
  function MpReport(pageThis) {
    _classCallCheck(this, MpReport);

    _defineProperty(this, "browedMap", {});

    this.pageThis = pageThis;
  }
  /**
   * 监听页面上存在的元素,使用轮询监听的优势是能监听到v-if的变化。
   * 除非再重新initObersever一次
   */


  _createClass(MpReport, [{
    key: "initObserver",
    value: function initObserver() {
      var _this = this;

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      var pageThis = this.pageThis;
      this.observer = wx.createIntersectionObserver(pageThis, {
        observeAll: true
      });
      this.observer.relativeToViewport().observe('.observer-container >>> .mp-observer-item', function (itemInfo) {
        var _pageLevelReportMap$g;

        var elementId = _this.generateId(itemInfo.dataset.mp, itemInfo.dataset.stat);

        if (!((_pageLevelReportMap$g = pageLevelReportMap.get(pageThis)) !== null && _pageLevelReportMap$g !== void 0 && _pageLevelReportMap$g.has(elementId)) && !globalComponentReportSet.has(elementId)) {
          var _pageLevelReportMap$g2;

          // 不重复初始化，页面切换的时候pageThis没有被销毁，故用其作为页面的id区别是否已经注册过曝光和离开事件
          _this.browReport(itemInfo);

          _this.leaveReport(itemInfo);

          var pageReports = (_pageLevelReportMap$g2 = pageLevelReportMap.get(pageThis)) !== null && _pageLevelReportMap$g2 !== void 0 ? _pageLevelReportMap$g2 : new Set();
          pageReports.add(elementId);
          pageLevelReportMap.set(pageThis, pageReports);

          if (itemInfo.dataset.mp.includes('|common')) {
            // 公共组件比如nav tab
            globalComponentReportSet.add(elementId);
          }
        } else {
          _this.leaveReport(itemInfo);
        }
      });
    }
  }, {
    key: "destory",
    value: function destory() {
      // 关闭观察器
      if (this.observer) {
        this.observer.disconnect();
      } // 清除埋点记录


      this.clear();
    }
  }, {
    key: "clear",
    value: function clear() {
      // 清除曝光记录
      this.browedMap = {};
    }
    /**
     * 页面pv上报
     */

  }, {
    key: "pv",
    value: function pv() {
      var _ref = this.pageThis || {},
          _ref$$mp = _ref.$mp;

      _ref$$mp = _ref$$mp === void 0 ? {} : _ref$$mp;
      var _ref$$mp$page = _ref$$mp.page;
      _ref$$mp$page = _ref$$mp$page === void 0 ? {} : _ref$$mp$page;
      var _ref$$mp$page$route = _ref$$mp$page.route,
          path = _ref$$mp$page$route === void 0 ? '' : _ref$$mp$page$route,
          _ref$$mp$query = _ref$$mp.query,
          query = _ref$$mp$query === void 0 ? {} : _ref$$mp$query;
      bi$1.pageStat(query, mapFunc("/".concat(path)));
    }
  }, {
    key: "browReport",
    value: function browReport(itemInfo) {
      var _itemInfo$dataset = itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.dataset,
          _itemInfo$dataset$mp = _itemInfo$dataset.mp,
          mp = _itemInfo$dataset$mp === void 0 ? '' : _itemInfo$dataset$mp,
          _itemInfo$dataset$sta = _itemInfo$dataset.stat,
          stat = _itemInfo$dataset$sta === void 0 ? '{}' : _itemInfo$dataset$sta;

      var mpArr = mp.split(/[\||｜]/); // 支持半角竖线

      if (mpArr.indexOf('brow') === -1) {
        return;
      } // 每次出现在视野中都上报


      if (itemInfo.intersectionRatio > 0.3) {
        biBrowStat(mpArr[0], JSON.parse(stat));
      }
    }
  }, {
    key: "generateId",
    value: function generateId(key, statExtJSONInfo) {
      return key + statExtJSONInfo;
    }
  }, {
    key: "leaveReport",
    value: function leaveReport(itemInfo) {
      var _this2 = this,
          _this$browedMap$;

      var _itemInfo$dataset2 = itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.dataset,
          _itemInfo$dataset2$mp = _itemInfo$dataset2.mp,
          mp = _itemInfo$dataset2$mp === void 0 ? '' : _itemInfo$dataset2$mp,
          _itemInfo$dataset2$st = _itemInfo$dataset2.stat,
          stat = _itemInfo$dataset2$st === void 0 ? '{}' : _itemInfo$dataset2$st;

      var mpArr = mp.split(/[\||｜]/); // 支持半角竖线

      if (mpArr.indexOf('leave') === -1) {
        return;
      }

      var leaveCb = function leaveCb(info) {
        var _info$path;

        var elementId = _this2.generateId(mp, stat);

        var stayTime = new Date().getTime() - _this2.browedMap[elementId].browTime;

        delete _this2.browedMap[elementId].browTime;
        var statExt = JSON.parse(stat);
        var key = mpArr[0];
        biHotTagReport(key, {
          type: exports.Operation.LEAVE,
          componentTag: ComponentTag.TEMPLATE,
          customPageName: "/".concat((_info$path = info === null || info === void 0 ? void 0 : info.path) !== null && _info$path !== void 0 ? _info$path : currentPageRoute())
        }, _objectSpread2({
          fstay_time: stayTime
        }, statExt));
      };

      var reportRecord = (_this$browedMap$ = this.browedMap["".concat(mp).concat(stat)]) !== null && _this$browedMap$ !== void 0 ? _this$browedMap$ : {}; // 还没有做离开上报前reportRecord.browTime会有值，所以initLeave这个函数可以多次调用也不会多次注册离开上报

      if (!reportRecord.browTime && itemInfo.intersectionRatio > 0) {
        reportRecord.browTime = new Date().getTime();
        this.browedMap["".concat(mp).concat(stat)] = reportRecord;
        addPageLeaveCallBack(leaveCb);
      } else if (itemInfo.intersectionRatio <= 0) {
        leaveCb(itemInfo);
      }
    }
  }]);

  return MpReport;
}();
/**
 * @description 在mixin的onLoad上面使用此方法获得实例
 * @param page vue实例，在生命周期中的this可以获取
 * @returns 上报实例方法，功能包含初始化，上报记录清理，页面pv上报
 */

exports.mpReportInstance = void 0;
var hasInited = false;
var browInit = function browInit(page) {
  var _getGlobalConfig$clos;

  exports.mpReportInstance = new MpReport(page);

  if (!hasInited) {
    observerPersisting();
    hasInited = true;
  }

  if (!((_getGlobalConfig$clos = getGlobalConfig().closePv) !== null && _getGlobalConfig$clos !== void 0 && _getGlobalConfig$clos.mp)) {
    exports.mpReportInstance.pv();
  }

  return {
    mpReport: exports.mpReportInstance
  };
};

function addPageLeaveCallBack(cb) {
  listeners.push(cb);
}

var listeners = [];
var lastInfo; // @ts-ignore

if ((_wx = wx) !== null && _wx !== void 0 && _wx.onAppRoute) {
  var _wx2;

  // @ts-ignore
  (_wx2 = wx) === null || _wx2 === void 0 ? void 0 : _wx2.onAppRoute(function (info) {
    listeners.forEach(function (fn) {
      return fn(lastInfo);
    });
    listeners.length = 0; // 清空数组且不更新引用地址

    lastInfo = info;
  });
}

function observerPersisting() {
  exports.mpReportInstance.initObserver(); // 闭包，mpReport在每次browInit或者其他时候就会更新page对象。
  // setTimeout：触发一次后，就停止了，无需手动clear。

  setTimeout(function () {
    observerPersisting();
  }, 1500);
}

function biBrowStat(key, params) {
  biHotTagReport(key, {
    type: exports.Operation.BROW,
    customPageName: "/".concat(currentPageRoute())
  }, params);
}

var vue2Flag = true;
/**
 * 检测当前vue版本，参考 https://github.com/vueuse/vue-demi 的判断方法
 */

function checkVueVerison(app) {
  debug('version', app.version);

  if (app.version.split('.')[0] === '2') {
    vue2Flag = true;
  } else {
    vue2Flag = false;
  }

  return vue2Flag;
}

/**
 * @description 结合lct方案完成的事件代理函数
 * @param event 点击事件的Event参数
 * @param fn 原有的绑定函数,比如@click="handleClick", fn代表handleClick
 * @param args 原有的函数的传参
 */

function proxyEventHandler(_x, _x2) {
  return _proxyEventHandler.apply(this, arguments);
}

function _proxyEventHandler() {
  _proxyEventHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event, fn) {
    var _this$fn2;

    var _event$currentTarget4,
        _event$currentTarget$2,
        _event$currentTarget5,
        _event$currentTarget6,
        statExt,
        mp,
        mpArr,
        _mp$split,
        _mp$split2,
        key,
        _event$currentTarget$3,
        rects,
        rect,
        data,
        _JSON$parse,
        row,
        column,
        hm,
        _hm$clickStatistics,
        _hm$clickStatistics2,
        xIndex,
        yIndex,
        fclickZone,
        _len,
        args,
        _key,
        _args2 = arguments;

    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            statExt = analysisDataSet(event === null || event === void 0 ? void 0 : (_event$currentTarget4 = event.currentTarget) === null || _event$currentTarget4 === void 0 ? void 0 : _event$currentTarget4.dataset);
            mp = (_event$currentTarget$2 = event === null || event === void 0 ? void 0 : (_event$currentTarget5 = event.currentTarget) === null || _event$currentTarget5 === void 0 ? void 0 : (_event$currentTarget6 = _event$currentTarget5.dataset) === null || _event$currentTarget6 === void 0 ? void 0 : _event$currentTarget6.mp) !== null && _event$currentTarget$2 !== void 0 ? _event$currentTarget$2 : '';
            mpArr = mp.split(/[\||｜]/);
            _mp$split = mp.split('|'), _mp$split2 = _slicedToArray(_mp$split, 1), key = _mp$split2[0];

            if (!mpArr.includes(exports.Operation.HEAT_MAP)) {
              _context2.next = 20;
              break;
            }

            _context2.next = 8;
            return getRectBySelector('.heat_map_item');

          case 8:
            rects = _context2.sent.flat();
            rect = rects.find(function (one) {
              return one.dataset.mp === event.currentTarget.dataset.mp;
            });
            data = (_event$currentTarget$3 = event.currentTarget.dataset.hmConfig) !== null && _event$currentTarget$3 !== void 0 ? _event$currentTarget$3 : '{}';
            _JSON$parse = JSON.parse(data), row = _JSON$parse.row, column = _JSON$parse.column;

            if (!row || !column) {
              console.error('请在data-hm-config的值提供行row和列column以及animateDurationTime参数，包裹在JSON对象中');
            }

            if (rect) {
              _context2.next = 16;
              break;
            }

            console.log('获取元素标识失败,检查v-stat携带的标识是否变化');
            return _context2.abrupt("return");

          case 16:
            hm = new HeatMap({
              getBoundingClientRect: function getBoundingClientRect() {
                return {
                  bottom: rect.height + event.target.offsetTop,
                  left: event.target.offsetLeft,
                  right: event.target.offsetLeft + rect.width,
                  top: event.target.offsetTop,
                  height: rect.height,
                  width: rect === null || rect === void 0 ? void 0 : rect.width,
                  x: rect.left,
                  y: rect.top
                };
              }
            }, row, column);
            _hm$clickStatistics = hm.clickStatistics(event.target.x, event.target.y), _hm$clickStatistics2 = _slicedToArray(_hm$clickStatistics, 2), xIndex = _hm$clickStatistics2[0], yIndex = _hm$clickStatistics2[1];
            fclickZone = (xIndex - 1) * hm.column + yIndex;

            if (xIndex > 0 && yIndex > 0) {
              heatMapStat(key, _objectSpread2(_objectSpread2({}, statExt), {}, {
                fclick_zone: fclickZone
              }));
            }

          case 20:
            if (mpArr.includes(exports.Operation.CLICK)) {
              clickStat(mpArr[0], statExt);
            }

            _context2.next = 26;
            break;

          case 23:
            _context2.prev = 23;
            _context2.t0 = _context2["catch"](0);
            console.log(_context2.t0);

          case 26:
            for (_len = _args2.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
              args[_key - 2] = _args2[_key];
            }

            this === null || this === void 0 ? void 0 : (_this$fn2 = this[fn]) === null || _this$fn2 === void 0 ? void 0 : _this$fn2.call.apply(_this$fn2, [this].concat(args));

          case 28:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[0, 23]]);
  }));
  return _proxyEventHandler.apply(this, arguments);
}

function clickStat(key, params) {
  biHotTagReport(key, {
    type: exports.Operation.CLICK,
    customPageName: "/".concat(currentPageRoute())
  }, params);
}
function scrollStat(key, params) {
  biHotTagReport(key, {
    type: exports.Operation.SCROLL,
    customPageName: "/".concat(currentPageRoute())
  }, params);
}
function heatMapStat(key, params) {
  biHotTagReport(key, {
    type: exports.Operation.CLICK,
    customPageName: "/".concat(currentPageRoute())
  }, params);
}
var scrollPosition = {
  scrollY: 0
}; // 暂时对每个元素共用一个 scrollY ，对滑动上报影响不大。

/**
 * @description 结合lct方案完成的事件代理函数
 * @param event 滑动事件的Event参数
 * @param fn 原有的绑定函数,比如@click="scrollHandler", fn代表scrollHandler
 * @param args 原有的函数的传参
 */

var proxyScrollHandler = debounce( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event, fn) {
    var _this$fn, _event$currentTarget, _event$currentTarget$, _event$currentTarget2, _event$currentTarget3;

    var _len2,
        args,
        _key2,
        statExt,
        mp,
        scrollY,
        fscnum,
        pageHeight,
        fscper,
        mpArr,
        diff,
        _args = arguments;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            for (_len2 = _args.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
              args[_key2 - 2] = _args[_key2];
            }

            this === null || this === void 0 ? void 0 : (_this$fn = this[fn]) === null || _this$fn === void 0 ? void 0 : _this$fn.call.apply(_this$fn, [this].concat(args));
            statExt = analysisDataSet(event === null || event === void 0 ? void 0 : (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 ? void 0 : _event$currentTarget.dataset);
            mp = (_event$currentTarget$ = event === null || event === void 0 ? void 0 : (_event$currentTarget2 = event.currentTarget) === null || _event$currentTarget2 === void 0 ? void 0 : (_event$currentTarget3 = _event$currentTarget2.dataset) === null || _event$currentTarget3 === void 0 ? void 0 : _event$currentTarget3.mp) !== null && _event$currentTarget$ !== void 0 ? _event$currentTarget$ : '';
            scrollY = event.detail.scrollTop;
            fscnum = scrollY / event.detail.scrollHeight;
            _context.next = 8;
            return getViewportHeight();

          case 8:
            pageHeight = _context.sent;
            fscper = event.detail.scrollTop / pageHeight;
            mpArr = mp.split(/[\||｜]/);
            diff = Math.abs(scrollPosition.scrollY - scrollY);

            if ((diff > 10 || diff / pageHeight > 0.03) && mpArr.includes(exports.Operation.SCROLL)) {
              scrollStat(mpArr[0], _objectSpread2(_objectSpread2({}, statExt), {}, {
                fscnum: fscnum,
                fscper: fscper
              }));
            }

            scrollPosition.scrollY = scrollY;

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function (_x3, _x4) {
    return _ref.apply(this, arguments);
  };
}(), 200);
function getViewportHeight() {
  return new Promise(function (resolve) {
    return wx.createSelectorQuery().selectViewport().scrollOffset(function (res) {
      resolve(parseFloat(res.scrollHeight));
    }).exec();
  });
}
function getRectBySelector(refSelector) {
  return new Promise(function (resolve) {
    var query = wx.createSelectorQuery();
    query.selectAll(".observer-container >>> ".concat(refSelector)).boundingClientRect();
    query.exec(function (res) {
      resolve(res);
    });
  });
}

exports.bi = void 0;
/**
 * 指令安装，初始化全局配置
 */

var plugin = {
  install: function install(app, options) {
    var route = options.route;
    setIsMp(options.mp);
    setGlobalConfig(options);
    checkVueVerison(app); // 初始化ppd-bi-sdk

    if (getIsMp()) {
      exports.bi = initMpBi(options);
    } else {
      exports.bi = initBi(options);
    } // 监听路由变化，并上报页面曝光


    initRouteListener(route, function () {
      var _options$closePv;

      if (!((_options$closePv = options.closePv) !== null && _options$closePv !== void 0 && _options$closePv.h5)) {
        biHotTagReport('page', {
          type: exports.Operation.BROW,
          componentTag: ComponentTag.PAGE
        });
      }
    }); // 监听H5路由变化

    getGlobalConfig().enableRouteListen && routeChangeListen(route, options); // 注册 directive

    var getPageFn = function getPageFn() {
      if (route !== null && route !== void 0 && route.currentRoute) {
        return getRouterName(route.currentRoute);
      }

      return getHash().slice(1);
    };

    initDirective(app, getPageFn);
  }
};
/**
 * 设置bi上报的基础字段，上报时会自动携带的字段,例如fuin,fopenid,fsource,fhost,fos,fosver,fclientver
 */

var setDynamicParams = function setDynamicParams(params) {
  exports.bi.setDynamicInfo(params);

  if (params.fuin || params.fopenid) {
    uinTask.resolve();
  }
};

exports.ExposureObserver = ExposureObserver;
exports.MpReport = MpReport;
exports.biBrow = biBrow;
exports.biClick = biClick;
exports.biHotTagReport = biHotTagReport;
exports.browInit = browInit;
exports.clickStat = clickStat;
exports.dispatchCustomEvent = dispatchCustomEvent;
exports.heatMapStat = heatMapStat;
exports.injectMpReportMethod = injectMpReportMethod;
exports.injectReportMethod = injectReportMethod;
exports.plugin = plugin;
exports.proxyEventHandler = proxyEventHandler;
exports.proxyScrollHandler = proxyScrollHandler;
exports.scrollStat = scrollStat;
exports.setDynamicParams = setDynamicParams;
exports.setFuin = setFuin;
exports.setFuinKey = setFuinKey;
exports.setMapPageNameFun = setMapPageNameFun;
exports.setPageName = setPageName;
exports.setUinKey = setUinKey;
